import { render, staticRenderFns } from "./altaVales.vue?vue&type=template&id=39abc205&scoped=true"
import script from "./altaVales.vue?vue&type=script&lang=js"
export * from "./altaVales.vue?vue&type=script&lang=js"
import style0 from "./altaVales.vue?vue&type=style&index=0&id=39abc205&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39abc205",
  null
  
)

export default component.exports